import RFFInputField from '../../form/RFFInputField';
import RFFSelectField from '../../form/RFFSelectField';

import {
  composeValidatorsForNonRequired,
  required,
  isCageCode,
  // isNationalItemIdentificationNumber,
  // isNationalStockNumber,
} from '../../../utils/validationUtils';
import { allUpperCase, nationalStockNumber } from '../../../utils/parseUtils';

export default [
  {
    name: 'partNum',
    label: 'Part No',
    component: RFFInputField,
    validate: required,
    disabled: true,
  },
  {
    name: 'niin',
    label: 'NSN',
    parse: nationalStockNumber,
    component: RFFInputField,
    // validate: composeValidatorsForNonRequired(
    //   isNationalItemIdentificationNumber,
    //   isNationalStockNumber,
    // ),
    disabled: true,
  },

  {
    name: 'description',
    label: 'Description',
    component: RFFInputField,
    toolTip: 'Description is limited to 50 characters',
    maxLength: 50,
  },
  {
    name: 'toolingRef',
    label: 'Tooling Ref No',
    component: RFFInputField,
  },
  {
    name: 'ownerCage',
    label: 'Tooling Cage',
    // disabled: true,
    parse: allUpperCase,
    validate: composeValidatorsForNonRequired(isCageCode),
    component: RFFInputField,
  },
  {
    name: 'designAlloy',
    label: 'Design-Alloy',
    component: RFFInputField,
  },
  {
    name: 'comments',
    label: 'Comments',
    component: RFFInputField,
    maxLength: 250,
  },
  {
    name: 'accessLevel',
    label: 'Visibility',
    component: RFFSelectField,
    placeholder: 'Access Level',
  },
  {
    name: 'category',
    label: 'Category',
    component: RFFSelectField,
    placeholder: 'Category',
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/ToolingManagementDefinitionForm/formConfig.jsx